import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {CookieService} from "../cookie/cookie.service";
import {GET_USER_INFO, KEYCLOAK_TOKEN, LOGOUT, PORTAL_LOGIN} from "../../constants/environment.constants";

@Injectable()
export class KeycloakService {
    constructor(private httpClient: HttpClient, private cookieService: CookieService) {}

    public refreshToken(refreshToken: string): Observable<any> {
        return new Observable<any>(observer => {
            this.httpClient.post(KEYCLOAK_TOKEN,
                `grant_type=refresh_token&client_id=dfosClient&refresh_token=${refreshToken}`,
                {
                    headers: {
                        "content-type": "application/x-www-form-urlencoded",
                    }
                }
            ).subscribe(
                response => {
                    observer.next(response);
                }, _ => {
                    observer.error();
                }
            );
        });
    }

    public getUserEmail(accessToken: string): Observable<any> {
        return new Observable<any>(observer => {
            this.httpClient.get(GET_USER_INFO,
                {
                    headers: {
                        "content-type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer " + accessToken
                    }
                }
            ).subscribe(
                response => {
                    observer.next(response);
                }, _ => {
                    this.cookieService.deleteCookie("token");
                    // window.open(PORTAL_LOGIN, "_self");
                }
            );
        });
    }

    public logout(refreshToken: string): Observable<any> {
        return new Observable<any>(observer => {
            this.httpClient.post(LOGOUT,
                `refresh_token=${refreshToken}&client_id=dfosClient`,
                {
                    headers: {
                        "content-type": "application/x-www-form-urlencoded"
                    }
                }
            ).subscribe(
                response => {
                    observer.next(response);
                }, _ => {
                    observer.error();
                }
            );
        });
    }
}
